import { Pipe, PipeTransform } from '@angular/core';
import { UnitType } from '../models/unit.model';
import { metersToFeets } from '../helpers/meters-to-feets.helpers';

@Pipe({
  name: 'elevation',
})
export class ElevationPipe implements PipeTransform {
  transform(
    meters: number,
    unit: UnitType,
    output: 'value' | 'unit' | 'both' = 'value',
    rounded: number = 1,
  ): string {
    const _unit: string = unit === 'imperial' ? 'ft' : 'm';
    const value: number = unit === 'metric' ? meters : metersToFeets(meters);

    switch (output) {
      case 'value':
        return value.toFixed(rounded);
      case 'unit':
        return _unit;
      case 'both':
        return `${value.toFixed(rounded)} ${_unit}`;
    }
  }
}
